import React, { createContext, useState, useContext } from "react";
import ToastNotification from "./Notification";

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({ show: false, message: "", type: "", icon: null });

  const showToast = ({ message, type, icon }) => {
    setToast({ show: true, message, type, icon });
    setTimeout(() => setToast({ show: false, message: "", type: "", icon: null }), 15000);
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <ToastNotification
        message={toast.message}
        icon={toast.icon}
        show={toast.show}
        onClose={() => setToast({ show: false, message: "", type: "", icon: null })}
      />
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  return useContext(ToastContext);
};
